const RegexForBot =
  /bot|crawler|spider|yahoo|slurp|duckduckgo|bingbot|yandex|sogou|exabot|facebot|ia_archiver|mediapartners|googlebot|adsbot-google|storebot-google|googleother|apis-google|feedfetcher-google|googlebot-news|adsbot-google-mobile|googlebot-images|adsbot-google-mobile-apps/i

function checkIfUserAgentIsABot() {
  try {
    if (typeof navigator === 'undefined') return false
    return RegexForBot.test(navigator.userAgent)
  } catch {
    return false
  }
}

export const isUserAgentABot = checkIfUserAgentIsABot()
